<div class="unsupported-language-notification">
  <div class="notification-dt">
    <div class="notification-left-container">
      <img src="assets/icons/info/size=24px,%20style=bold,%20color=orange.svg" alt="Icon/Info/Bold/Orange">
    </div>
    <p class="notification-info">
      <strong>Unsupported language detected:</strong> Contact language services for assistance. Detected language: {{ detectedLanguage }}.
    </p>
  </div>
</div>
